import React from 'react';
import PageTitle from '../../Components/PageTitle';
import Midpart from './Midpart';


function Quote() {
	return (
		<>
			<PageTitle title="Contact" />
			<Midpart />
		</>
	);
}

export default Quote;

